// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DrawingsManagerItem } from '../../cache/ObjectManager/DrawingsManagerItem';
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { ObjectManagerPanelBase } from './ObjectManagerPanelBase';
import { TerceraChartToolRenderer } from '@front/chart/Renderers/Tools/TerceraChartToolRenderer';
import { ToolsCache } from '@shared/commons/cache/ToolsCache';
import { TerceraChartActionEnum } from '@front/chart/TerceraChartAction';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { DataCache } from '@shared/commons/DataCache';
export class DrawingsManagerPanel extends ObjectManagerPanelBase {
    constructor() {
        super();
        this.ChartActionShowOnChart = TerceraChartActionEnum.ShowOnChart;
        this.ChartActionSettings = TerceraChartActionEnum.ToolSettings;
        this.ChartActionRemove = TerceraChartActionEnum.DeleteTool;
        this.ChartActionDeleteAll = TerceraChartActionEnum.DeleteAllTools;
        this.Name = 'DrawingsManagerPanel';
        this.headerLocaleKey = 'chart.head.line';
    }
    getType() {
        return PanelNames.DrawingsManagerPanel;
    }
    subscribe() {
        if (!isNullOrUndefined(this.Chart)) {
            ToolsCache.OnAddTool.Subscribe(this.AddItemToTable, this);
            ToolsCache.OnRemoveTool.Subscribe(this.RemoveItemFromTable, this);
        }
    }
    unsubscribe() {
        if (!isNullOrUndefined(this.Chart)) {
            ToolsCache.OnAddTool.UnSubscribe(this.AddItemToTable, this);
            ToolsCache.OnRemoveTool.UnSubscribe(this.RemoveItemFromTable, this);
        }
    }
    AddItemToTable(tool) {
        const quickTable = super.getQuickTable();
        if (isNullOrUndefined(quickTable)) {
            return;
        }
        if (tool.Instrument.Id === this.Chart.Instrument().Id) {
            const item = quickTable.AddItem(new DrawingsManagerItem(tool));
            item.cells[DrawingsManagerItem.SHOWONCHART_COL_INDEX].ReadOnly = !DataCache.boolRuleValue(RulesSet.IS_ALLOW_MIDDLE_REQUEST_ON_CHART);
        }
    }
    populateItemsDirect() {
        super.populateItemsDirect();
        if (isNullOrUndefined(this.Chart)) {
            return;
        }
        for (const window of this.Chart.windowsContainer.Windows) {
            const renderer = window.GetRenderer(TerceraChartToolRenderer);
            this.populateItems(renderer.tools);
        }
    }
    populateItems(tools) {
        for (const tool of tools) {
            this.AddItemToTable(tool.dataCacheTool);
        }
    }
}
